"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StylesWatcher = void 0;
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var react_redux_2 = require("react-redux");
var getIsMediumScreen_1 = require("../../state/getters/getIsMediumScreen");
var getGlobalStylesString_1 = require("../../styles/getGlobalStylesString");
var emotion_1 = require("emotion");
var description = 'StylesWatcher';
var StylesWatcher = function (_a) {
    var setAppStyles = _a.setAppStyles;
    var dispatch = (0, react_redux_2.useDispatch)();
    var refreshForColorTheme = (0, react_redux_1.useSelector)(function (state) {
        var _a, _b, _c;
        return (!((_a = state.cookieStorage) === null || _a === void 0 ? void 0 : _a.uiColorTheme) &&
            ((_b = state.currentUnscopeUser) === null || _b === void 0 ? void 0 : _b.uiColorTheme) &&
            ((_c = state.cookieStorage) === null || _c === void 0 ? void 0 : _c.signedIntoDashboard) /* need this otherwise, logout will trigger this */);
    });
    var uiColorTheme = (0, react_redux_1.useSelector)(function (state) {
        var _a;
        return ((_a = state.cookieStorage) === null || _a === void 0 ? void 0 : _a.uiColorTheme) || undefined;
    });
    (0, react_1.useEffect)(function () {
        if (refreshForColorTheme) {
            dispatch({
                type: 'SET_COOKIE_STORAGE',
                description: description,
                values: {
                    uiColorTheme: 'DarkMode',
                },
            });
            setAppStyles('DarkMode');
        }
    }, [refreshForColorTheme, dispatch]);
    var isMediumScreen = (0, react_redux_1.useSelector)(function (state) {
        return (0, getIsMediumScreen_1.getIsMediumScreen)({ state: state });
    });
    (0, react_1.useEffect)(function () {
        if (document) {
            document.getElementsByTagName('html')[0].style.fontSize = isMediumScreen
                ? '16px'
                : '18px';
        }
    }, [isMediumScreen]);
    (0, react_1.useEffect)(function () {
        var styles = (0, getGlobalStylesString_1.getGlobalStylesString)({ isMediumScreen: isMediumScreen });
        (0, emotion_1.injectGlobal)("\n      :root {\n        ".concat(styles, "\n      }\n    "));
    }, [isMediumScreen, uiColorTheme]);
    return null;
};
exports.StylesWatcher = StylesWatcher;
